import AccessoryPage from './AccessoryPage';

export default AccessoryPage;
